import axios from 'axios';
import { USER_API_BASE_DEVICES_URL, getApiUrl } from '../../Constants/Api';

export class AppPhasesDialogService {
    getAppPhases = (clientKey, deviceKey) => {
        return axios.get(`${getApiUrl()}${USER_API_BASE_DEVICES_URL}/${clientKey}/${deviceKey}`)
    }
}

export default new AppPhasesDialogService();